export default {"src":"/_next/static/media/LV.6bc5360e.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};